export const INITIAL_LOAD_BEGIN = "INITIAL_LOAD_BEGIN";
export const INITIAL_LOAD_SUCCESS = "INITIAL_LOAD_SUCCESS";
export const INITIAL_LOAD_ERROR = "INITIAL_LOAD_ERROR";
export const STORE_PANEL_DATA = "STORE_PANEL_DATA";